import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { stylesMapping } from "../car-details-card-revamp/constants";

const CarDetailsInfoStrip = ({ type = "PRICE_DROP", stripInfo = { label: "", icon: "" } }) => {
    if (!type) return null;
    return (
        <div styleName={`styles.stripContainer ${stylesMapping[type] || ""}`}>
            <img src={stripInfo.icon} alt={stripInfo.label} />
            <p styleName={"styles.label"}>{stripInfo.label}</p>
        </div>
    );
};

CarDetailsInfoStrip.propTypes = {
    type: PropTypes.string,
    stripInfo: PropTypes.object
};

export default CarDetailsInfoStrip;
